<template>
  <div>
    <form enctype="multipart/form-data" novalidate>
      <input
        type="file"
        ref="fileRef"
        accept="image/png, image/jpeg"
        class="input-file"
        @change="onFileChange"
      >
    </form>

    <v-img
      sizes="300px"
      aspect-ratio="1"
      :src="profileImage.url"
      :srcset="profileImage.srcset"
      :style="{'background-color': profileImage.color }"
    >
      <v-alert
        v-if="errors.length"
        :value="true"
        type="error"
        dismissible
        @input="errors = []"
      >{{ errors.join(' ') }}</v-alert>
      <template v-else>
        <div class="text-xs-right">
          <tk-btn
            v-if="percentCompleted < 0"
            flat
            small
            class="cam-btn ma-0"
            @click="$refs.fileRef.click()"
          >
            <v-icon>fas fa-camera</v-icon>
          </tk-btn>

          <v-progress-circular
            v-else
            style="background-color: #ffffff73"
            class="ma-1"
            :rotate="360"
            :value="percentCompleted"
          >{{ percentCompleted }}</v-progress-circular>
        </div>
      </template>
    </v-img>
  </div>
</template>

<script>
import { convertToBase64 } from "@/utils/FileHelpers";

export default {
  data() {
    return {
      percentCompleted: -1,
      errors: []
    };
  },

  computed: {
    profileImage() {
      if (this.$auth.currentUser.media) return this.$auth.currentUser.media;
      return {
        url: "/static/img/user.png"
      };
    }
  },

  methods: {
    async onFileChange(e) {
      this.error = null;
      const file = e.target.files[0];
      const size = file.size / (1024 * 1024);

      const base64 = await convertToBase64(file);
      const config = {
        onUploadProgress: progressEvent => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.percentCompleted = percentage === 100 ? 99 : percentage;
        }
      };
      this.percentCompleted = 1;
      const payload = {
        image: base64
      };

      try {
        const resp = await this.$axios.put("profile/avatar", payload, config);
        console.log(resp);
        this.$auth.currentUser.media = resp.data["data"];
        console.log(this.$auth.currentUser);
      } catch (error) {
        if (error.data && error.data.errors && error.data.errors.image) {
          this.errors = error.data.errors.image;
        }
      }

      this.percentCompleted = -1;
    }
  }
};
</script>

<style lang="scss" scoped>
.cam-btn {
  min-width: 30px;
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.input-file {
  display: none;
}
</style>
